import { login, emailLogin } from '@/api/login/user'
import { getToken, setToken, removeToken } from '@/utils/auth'

const state = {
  token: getToken(),
}

const mutations = {
  SET_TOKEN: (state, token) => {
    state.token = token
  },
}

const actions = {
  // user login
  login({ commit }, userInfo) {
    const { phoneNumber, verificationCode } = userInfo
    return new Promise((resolve, reject) => {
      login({ phoneNumber: phoneNumber, verificationCode: verificationCode }).then(response => {
        const { data } = response
        commit('SET_TOKEN', data.accessToken)
        setToken(data.accessToken)
        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  },
  login2({ commit }, userInfo) {
    const { email, verificationCode } = userInfo
    return new Promise((resolve, reject) => {
      emailLogin({ email: email, verificationCode: verificationCode }).then(response => {
        const { data } = response
        commit('SET_TOKEN', data.accessToken)
        setToken(data.accessToken)
        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  },

  // remove token
  resetToken({ commit }) {
    return new Promise(resolve => {
      commit('SET_TOKEN', '')
      removeToken()
      resolve()
    })
  },
}
export default {
  namespaced: true,
  state,
  mutations,
  actions
}
